import React from "react";
import { Button } from "../../components";

interface IButtonProps {
  children?: React.ReactNode;
  endIcon?: React.ReactNode;
  display?: "none";
  disabled?: boolean;
  ref?: React.Ref<HTMLButtonElement>; // React 19: ref tiesiogiai įtrauktas į props
}

const SubmitButton = ({ children, disabled, ref, ...props }: IButtonProps) => {
  return (
    <Button
      type="submit"
      fullWidth={true}
      disabled={disabled}
      ref={ref}
      {...props}
    >
      {children || "Išsaugoti"}
    </Button>
  );
};

export default React.memo(SubmitButton);
